(function () {
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function changeCartLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCartItems(cart); })
      .catch(function (err) { console.error('Cart update error:', err); });
  }

  function updateMiniCartBar(cart) {
    var bar = document.getElementById('mini-cart-bar');
    if (!bar) return;

    if (!cart.item_count) {
      if (bar.classList.contains('is-visible')) {
        bar.classList.remove('is-visible');
        setTimeout(function () { bar.hidden = true; }, 500);
      } else {
        bar.hidden = true;
      }
      return;
    }

    var thumb = document.getElementById('mini-cart-thumb');
    var badge = document.getElementById('mini-cart-badge');
    var countEl = document.getElementById('mini-cart-count');
    var subtotalEl = document.getElementById('mini-cart-subtotal');
    var firstItem = cart.items[0];

    if (thumb && firstItem && firstItem.image) {
      thumb.style.backgroundImage = 'url(' + firstItem.image + ')';
    }
    if (badge) {
      var prevCount = badge.textContent;
      badge.textContent = cart.item_count;
      if (prevCount && prevCount !== String(cart.item_count)) {
        badge.classList.remove('is-pulsing');
        void badge.offsetWidth;
        badge.classList.add('is-pulsing');
      }
    }
    if (countEl) countEl.textContent = cart.item_count === 1 ? '1 item' : cart.item_count + ' items';
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    bar.hidden = false;
    requestAnimationFrame(function () { bar.classList.add('is-visible'); });
  }

  function renderCartItems(cart) {
    var itemsEl = document.getElementById('cart-items');
    var subtotalEl = document.getElementById('cart-subtotal');
    updateMiniCartBar(cart);
    if (!itemsEl) return;

    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      if (subtotalEl) subtotalEl.textContent = '$0.00';
      return;
    }

    var html = '';
    cart.items.forEach(function (item, index) {
      var line = index + 1;
      var hasSubscription = item.selling_plan_allocation;
      var planName = hasSubscription ? item.selling_plan_allocation.selling_plan.name : '';
      var variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      var imgHtml = item.image
        ? '<img class="cart-item__img" src="' + item.image + '" alt="' + item.product_title + '">'
        : '<div class="cart-item__img-placeholder"></div>';

      html += '<div class="cart-item">';
      html += imgHtml;
      html += '<div class="cart-item__body">';
      html += '<div class="cart-item__name">' + item.product_title + '</div>';
      if (variantTitle) {
        html += '<div class="cart-item__variant">' + variantTitle + '</div>';
      }
      if (hasSubscription && planName) {
        html += '<div class="cart-item__plan-badge">↻ ' + planName + '</div>';
      }
      html += '<div class="cart-item__price-row">';
      html += '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>';
      html += '</div>';
      html += '<div class="cart-item__controls">';
      html += '<div class="cart-item__qty-control">';
      html += '<button class="cart-item__qty-btn" data-line="' + line + '" data-action="decrease" aria-label="Decrease quantity">−</button>';
      html += '<span class="cart-item__qty-num">' + item.quantity + '</span>';
      html += '<button class="cart-item__qty-btn" data-line="' + line + '" data-action="increase" aria-label="Increase quantity">+</button>';
      html += '</div>';
      html += '<button class="cart-item__remove" data-line="' + line + '" aria-label="Remove item">Remove</button>';
      html += '</div>';
      html += '</div>';
      html += '</div>';
    });

    itemsEl.innerHTML = html;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    itemsEl.querySelectorAll('.cart-item__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.dataset.line, 10);
        var qtySpan = btn.parentElement.querySelector('.cart-item__qty-num');
        var currentQty = qtySpan ? parseInt(qtySpan.textContent, 10) : 1;
        var newQty = btn.dataset.action === 'increase' ? currentQty + 1 : currentQty - 1;
        changeCartLine(line, Math.max(0, newQty));
      });
    });

    itemsEl.querySelectorAll('.cart-item__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeCartLine(parseInt(btn.dataset.line, 10), 0);
      });
    });
  }

  function openCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    var overlay = document.getElementById('cart-overlay');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCartItems(cart); })
      .catch(function () {});
  }

  function closeCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    var overlay = document.getElementById('cart-overlay');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function setSelectedPlan(plan) {
    document.querySelectorAll('.plan-card').forEach(function (c) {
      c.dataset.selected = (c.dataset.plan === String(plan)) ? 'true' : 'false';
    });
  }

  function init() {
    var btn = document.getElementById('checkout-btn');

    // Auto-open drawer when redirected from /cart
    if (new URLSearchParams(window.location.search).get('open-cart') === '1') {
      history.replaceState(null, '', window.location.pathname + window.location.hash);
      openCartDrawer();
    } else {
      // Sync the mini cart bar with any existing cart on page load, without opening the drawer
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(renderCartItems)
        .catch(function () {});
    }

    var closeBtn = document.getElementById('cart-close');
    var overlay = document.getElementById('cart-overlay');
    var continueBtn = document.getElementById('cart-continue');
    var miniCartBar = document.getElementById('mini-cart-bar');
    if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
    if (overlay) overlay.addEventListener('click', closeCartDrawer);
    if (continueBtn) continueBtn.addEventListener('click', closeCartDrawer);
    if (miniCartBar) miniCartBar.addEventListener('click', openCartDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCartDrawer();
    });

    if (!btn) return;

    document.querySelectorAll('.plan-card').forEach(function (card) {
      card.addEventListener('click', function () { setSelectedPlan(card.dataset.plan); });
    });

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.dataset.loading === 'true') return;

      var selected = document.querySelector('.plan-card[data-selected="true"]');
      if (!selected || !selected.dataset.variantId) return;

      var item = { id: selected.dataset.variantId, quantity: 1 };
      if (selected.dataset.sellingPlanId) {
        item.selling_plan = selected.dataset.sellingPlanId;
      }

      var originalText = btn.textContent;
      btn.dataset.loading = 'true';
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Add to cart failed');
          return r.json();
        })
        .then(function () {
          btn.textContent = originalText;
          btn.dataset.loading = 'false';
          openCartDrawer();
        })
        .catch(function (err) {
          console.error('Checkout error:', err);
          btn.textContent = originalText;
          btn.dataset.loading = 'false';
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
